import { List } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { isDateFormat, isSingleDateFormat } from "../../../common/dateFormat";
import { API_CANDIDATE } from "../../../utils/config";
import ExtraCurricular from "./Extra_curricular/ExtraCurricular";
import ProjectTable from "./ProjectTable/ProjectTable";
import SkillsData from "./SkillsTable/SkillsData";
import SkillsTable from "./SkillsTable/SkillsTable";
import ResumeTable from "./Table/ResumeTable";

function PrintResume() {
  const [fetchPersonal, setfetchPersonal] = useState([]);
  const [fetchExpSummary, setFetchExpSum] = useState([]);
  const [fetchCareer, setFetchCareer] = useState([]);
  const [professional, setProfessional] = useState([]);
  const [certificate, setCertificate] = useState([]);
  const [award, setAward] = useState([]);
  const [academic, setAcademic] = useState([]);
  const [skills, setSkills] = useState([]);
  const [extra, setExtra] = useState([]);
  const [project, setProject] = useState([]);

  useEffect(() => {
    fetchResume();
  }, []);

  const fetchResume = () => {
    axios
      .get(`${API_CANDIDATE}/v1/api/can-resume`, { withCredentials: true })
      .then((res) => {
        console.log(res.data);
        setfetchPersonal(res.data.personalDetails);
        setFetchExpSum(res.data.expSummary);
        setFetchCareer(res.data.careerObject);
        setProfessional(res.data.professionalDetail);
        setCertificate(res.data.certificate);
        setAward(res.data.award);
        setAcademic(res.data.education);
        setSkills(res.data.canSkill);
        setExtra(res.data.extcuActivities);
        setProject(res.data.projectDetail);
        setProfessional(res.data.professionalDetail);
        console.log(res.data.summary);
      })

      .catch((err) => {
        console.log("err", err);
      });

  };

  console.log(academic);

  // function for displaying personal info
  const displayPersonalInfo = () => {
    return fetchPersonal.map((personal) => (
      <h3 key={personal}>{`${
        personal.firstName.charAt(0).toUpperCase() + personal.firstName.slice(1)
      } ${personal.lastName}`}</h3>
    ));
  };

  // function for displaying mail
  const displayContactInfoMail = () => {
    return fetchPersonal.map((contact) => (
      <span
        style={{ fontSize: "0.875rem" }}
        key={contact}
      >{`+${contact.dialingCode} ${contact.mobileNo}  ${contact.eMailId}`}</span>
    ));
  };

  // function for displaying summary
  const displaySummary = () => {
    return fetchExpSummary.map((summary) => (
      <p
        style={{ fontSize: "0.875rem" }}
        key={summary}
      >{`${summary.experienceSumm}  `}</p>
    ));
  };

  //  function for displaying career
  const displayCareer = () => {
    return fetchCareer.map((career) => (
      <p key={career}> {`${career.careerObjective}  `}</p>
    ));
  };
  console.log();

  return (
    <Container style={{ maxWidth: "80%", marginTop: "2.5rem !important" }}>
      {displayPersonalInfo()}
      {displayContactInfoMail()}
      {displaySummary()}
      <div>
        <h6
          style={{
            fontSize: "1.125rem",
            fontWeight: "bold",
            marginTop: "0.625rem",
          }}
        >
          Carrer Objective &emsp; &emsp; &emsp; &emsp;{" "}
        </h6>
        <p> {displayCareer()} </p>
        {/* {`Worked as a ${profes.designation} in ${profes.location} from ${profes.fromDate && profes.toDate ? isDateFormat(profes.fromDate,profes.toDate):""} `}{" "} */}
      </div>

      <div>
        {/* -------------professional--------- */}
        <h6
          style={{
            fontSize: "1.125rem",
            fontWeight: "bold",
            marginTop: "10px",
          }}
        >
          {" "}
          Proffesional Experience{" "}
        </h6>
        {professional.map((profes) => (
       
          <ol style={{listStyleType:'disc'}}>
<li>

           <p key={profes.id}>
             {" "}
             {`Worked as a ${profes.designation} in ${profes.location} from ${
               profes.fromDate && profes.toDate
                 ? isDateFormat(profes.fromDate, profes.toDate)
                 : ""
             } `}{" "}
           </p>
          
</li>
</ol>
        

          
        ))}
      </div>

      {/* Training Section  */}

      {/* ------------Academic Details--------------- */}

      <div>
        <h6
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            marginTop: "10px",
          }}
        >
          Academic Detail
        </h6>
        <ResumeTable data={academic} />
      </div>

      {/* ------------Skill--------------- */}

      <div>
        <h6
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            marginTop: "10px",
          }}
        >
          Skills
        </h6>
        <SkillsTable data={skills} />
      </div>

      {/* --------------Project Details------ */}

      <div>
        <h6
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            marginTop: "10px",
          }}
        >
          Project details
        </h6>
        <ProjectTable data={project} />
      </div>
      {/* --------Extra curricular---------- */}

      <div>
        <h6
          style={{
            fontSize: "18px",
            fontWeight: "bold",
            marginTop: "10px",
          }}
        >
          Extracurricular Activities{" "}
        </h6>

        <ExtraCurricular data={extra} />
      </div>

      <h6
        style={{
          fontSize: "18px",
          fontWeight: "bold",
          marginTop: "10px",
        }}
      >
        Training & Certification
      </h6>
      {certificate.map((certificate) => (
        <ol style={{listStyleType:'disc'}}>
          <li>

        
        <p
          style={{
            fontSize: "15px",
            // fontWeight:"lighter",
            marginTop: "10px",
          }}
          key={certificate.id}
        >
          {` ${certificate.certName}  ${
            certificate.startDate
              ? certificate.endDate &&
                isDateFormat(certificate.startDate, certificate.endDate)
              : ""
          } `}{" "}
        </p>
        </li>
        </ol>
      ))}
      {/* // ---------Award------------ */}

      <h6
        style={{
          fontSize: "18px",
          fontWeight: "bold",
          marginTop: "10px",
        }}
      >
        {" "}
        Achivement{" "}
      </h6>
      {award.map((awardData) => (
        <ol style={{listStyleType:'disc'}}>
          <li>

        <p key={awardData.id}>
          {` ${awardData.awardName} ${
            awardData.dateAwarded
              ? isSingleDateFormat(awardData.dateAwarded)
              : ""
          } `}{" "}
        </p>
          </li>
        </ol>
      ))}
    </Container>
  );
}

export default PrintResume;
